export const GTM_EVENT_SEND_SUCCESS_LOGIN_KEY = 'NeedToSendLoginEvent';
export const LOGIN_ALERT_HAS_BEEN_CLOSED_BY_USER_KEY = 'LoginAlertWasClosedByUser';
